export default "__VITE_PUBLIC_ASSET__b7069e53__"